import { Box, Typography, Divider } from "@mui/material";
import React from "react";

const ReviewFormTitle = () => {
  return (
    <Box maxWidth="max-content">
      <Typography variant="h6" color={"#146ED2"} fontWeight={800}>
        Review Forms
      </Typography>
      <Divider sx={{ borderBottomWidth: "5px",backgroundColor:"#146ED2",opacity:"0.8" }} />
    </Box>
  );
};

export default ReviewFormTitle;
